<template>
  <v-toolbar v-on="$listeners" v-bind="$attrs" dense dark color="primary">
    <v-toolbar-title>{{ title }}</v-toolbar-title>
    <v-spacer />
    <v-btn icon dark @click="$emit('close')">
      <v-icon>close</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: 'Dialog title',
      },
    },
  }
</script>